import { Component, OnInit ,Input} from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ITBQuoteEditBidComponent } from '../itb-quote-edit-bid/itb-quote-edit-bid.component';
import { ITBEditBidComponent } from '../itb-edit-bid/itb-edit-bid.component';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgFor, NgClass, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-itb-quote-select-products',
    templateUrl: './itb-quote-select-products.component.html',
    styleUrls: ['./itb-quote-select-products.component.scss'],
    imports: [NgFor, NgClass, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class ITBQuoteSelectProductsComponent implements OnInit {
  private modalRef: NgbModalRef;
  COI: boolean =false;
  ITB: boolean= false;
  OpenNegotiation:boolean=true;
  @Input() code:any;
  @Input() price:number;
  @Input() tabName: any;
  @Input() indexPrice:number;
  @Input() productsInfo: any;
  @Input() indexValue: any;
  @Input() dischargePortshw:any;
  @Input() quantityshw:any;
  productInfo=[];
  tabValue: any;
  material1: boolean =true;
  public checkMaterial1:boolean;
  biddingTerms = '';
  requestParams: any;
  productValue:any;
  parameter=[];
  constructor(public ActiveModal: NgbActiveModal,private customProductService: CustomProductsService,public ModalService:NgbModal,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.indexValue = 0;
    console.log(this.productsInfo);
    this.productInfo=this.productsInfo && this.productsInfo.quoteEntries;
    this.productInfo.map(val=>{
      if(val  && val.checked === undefined){
        val.checked = false
      }else if(val  && val.checked === true){
        val.checked = true
      }else if(val  && val.checked === false){
        val.checked = false
      }
    })
  }
  close(): any {
    this.productInfo.map(val=>{
        val.checked = false
    })
    this.ActiveModal.close();
  }
  onCheckboxChange(e,event) {
    let checked = event.target.checked;
    if(checked){
    if (e) {
     this.parameter.push(e);
    console.log(this.parameter);
    }else{
      this.parameter.push();
      console.log(this.parameter);
    }
  }
  if(!checked){
    const index = this.parameter.findIndex(x => x.value === e);
    this.parameter.splice(index, 1);
  }
  }
  Openmodal(){
    this.ActiveModal.close();
    if(this.parameter.length > 1){
      const ModalRef = this.modalService.open(ITBQuoteEditBidComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.code =this.productsInfo
      console.log(this.productsInfo,'pf')
        ModalRef.componentInstance.price = this.parameter[this.indexValue].tcPrice.value;
        if(this.parameter[this.indexValue].displayRCPriceConfig.displayRCPrice==true){
          ModalRef.componentInstance.indexPrice = this.parameter[this.indexValue].rcPrice.value;
        }
      ModalRef.componentInstance.index =this.parameter;
     ModalRef.componentInstance.indexValue = this.indexValue;
     ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
     ModalRef.componentInstance.quantityshw = this.quantityshw;
    }else{
      const ModalRef = this.ModalService.open(ITBEditBidComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.productsEntry = this.parameter;
      ModalRef.componentInstance.selectProduct = this.productsInfo;
      ModalRef.componentInstance.price=this.price
      ModalRef.componentInstance.indexPrice=this.indexPrice
      ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
      ModalRef.componentInstance.quantityshw = this.quantityshw;
    }
      }
}
